if ( $(".coursenames").length ) {

    //console.log('exists!');

    const dateSelect = $(".dateselect select");
    const priceInput = $(".priceinput input");
    const priceTotalInput = $(".totalprice input");
    const requestInput = $(".likeddate");
    const action = $(".bookingform").attr( "action" );


 //console.log(priceInput);

    if ( action === '/course-booking-form/') { // reset dropdown attributes if page reloaded
        $(".coursenames select option").each( function() {
            $(this).removeAttr('selected' );
        });
        $(".coursenames select option:first-child").attr( 'selected', "selected" );
    } else {
        $(".coursenames select option:first-child").removeAttr( 'selected' ); //remove selected from the default option if booked via calendar
    }

    requestInput.css( {"display":"none"} );

    $(".coursenames select").on( 'change', function() {

        let selected = $(this).children("option:selected").val();

        function createOption( value, text) {
            let newOptions = $( '<option>' );
            newOptions.attr( 'value', value ).text( text );
            dateSelect.append( newOptions );
        }

        if( selected !== '' ) {

            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                  action: 'update_dates',
                  selected: selected
                },
                success: function (response) {

                    dateSelect.empty();

                    let newOptions = $( '<option>' );
                    newOptions.addClass( "gf_placeholder" ).attr( 'value', '' ).attr( 'selected', "selected" ).text( 'Choose a date' );
                    dateSelect.append( newOptions );

                    const data = $.parseJSON( response );

                    if ( data.dates ) {
                        $.each( data.dates, function(index, value) {
                            createOption( value.value, value.text );
                        });
                        createOption( 'request-new-date', 'Request new date' );

                    } else {
                        createOption( 'request-new-date', 'Request new date' );
                    }

                    let price;

                    // Create the number formatter.
                    const formatter = new Intl.NumberFormat( 'en-UK', {
                        style: 'currency',
                        currency: 'GBP',

                        // These options are needed to round to whole numbers if that's what you want.
                        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
                    });

                    if( data.price ) {
                        price = formatter.format( data.price );
                    } else {
                        price = formatter.format( 0 );
                    }
                    priceInput.val(price);

                    $(".numbdelegates select").on( 'change', function() {
                        var numbDelegates = parseInt($(".numbdelegates select").val());
                        var priceTotal = formatter.format(numbDelegates * parseInt(data.price));

                        priceTotalInput.val(priceTotal + " (+VAT)");
                    });

                },
                error: function (response) { console.log(response) }
            });

        } else {
            dateSelect.empty();

            let newOptions = $( '<option>' );
            newOptions.addClass( "gf_placeholder" ).attr( 'value', '' ).attr( 'selected', "selected" ).text( 'Choose a date' );
            dateSelect.append( newOptions );

            createOption( 'no-dates-available', 'No dates available for this course' );
        }

        requestInput.css( {"display":"none"} );
    });

    $(".dateselect select").on( 'change', function() {
        let selected = $(this).children("option:selected").val();

        if ( selected === 'request-new-date' ) {
            requestInput.css( {"display":"block"} );
        } else {
            requestInput.css( {"display":"none"} );
        }
    });

}
